import SEO from 'components/SEO';
import LoadableContentSpinner from 'components/Universal/LoadableContentSpinner';
import HeaderContext from 'providers/HeaderProvider';
import ThemeContext from 'providers/ThemeProvider';
import React, { useContext, useEffect } from 'react';
import loadable from '@react-loadable/revised'

const CoreTemplate = loadable({
	loader: () => import('components/Templates/offer/CoreTemplate'),
	loading: LoadableContentSpinner
});

export default function calculatorOffer() {
	const { setHeader } = useContext(HeaderContext);
	const { setPrimaryColor } = useContext(ThemeContext);

	useEffect(() => {
		setHeader({ title: 'Oferta Limit', isLimit: true });
		setPrimaryColor('#25848D');
	}, []);

	return (
		<div>
			<SEO
				title='Indywidualna wycena kosztu faktoringu krajowego. Kalkulator oferty 100% online.'
				keywords='faktoring krajowy, koszt faktoringu, koszty faktoringu, faktoring koszt, faktoring koszty'
				description='Dopasuj ofertę do Twoich potrzeb. Elastyczne podejście. Stawki wykupu już od 0,79%. Bezpłatnie sprawdzimy Twoich kontrahentów. Pieniądze wypłacimy natychmiast. Oferta w 15 sekund. Faktoring krajowy.'
			/>

			<CoreTemplate isLimitOffer />
		</div>
	);
}
